import Comm from "../comm/comm";

class Context {
    static LastErrorCode = 0;

    static ctx = null;
    static Guid() {
        var sGuid = "";
        for (var i = 0; i < 32; i++) {
            sGuid += Math.floor(Math.random() * 0xf).toString(0xf);
        }
        return sGuid;
    }

    static LoadFromDBIfNull() {
        if (Context.ctx !== null) return;
        var ctString = localStorage.getItem("Context");
        if (ctString !== null) Context.ctx = JSON.parse(ctString);
    }

    static IsLogged() {
        Context.LoadFromDBIfNull();
        return Context.ctx !== null;
    }

    static GetContext() {
        Context.LoadFromDBIfNull();
        return Context.ctx;
    }

    static HasRight(right) {
        Context.LoadFromDBIfNull();
        return (
            Context.ctx != null &&
            (Context.ctx.username === "admin" ||
                (Context.ctx.permissions !== null && Context.ctx.permissions.hasOwnProperty(right)))
        );
    }

    static Login(ct) {
        localStorage.setItem("Context", JSON.stringify(ct));
        Context.ctx = ct;
    }

    static Logout() {
        localStorage.removeItem("Context");
        Context.ctx = null;
    }

    static ErrorResponse(history) {
        switch (Context.LastErrorCode) {
            case 1:
            case 2:
                history.push("/login");
                Context.LastErrorCode = 0;
                return true;
            case 3:
                history.push("/error");
                Context.LastErrorCode = 0;
                return true;
            default:
                break;
        }

        return false;
    }

    static RenderNotOK(history) {
        var ctx = Context.GetContext();

        if (ctx == null) {
            history.push("/login");
            return true;
        } else {
            Comm.SessionUser(ctx.Sid);
        }

        return Context.ErrorResponse(history);
    }
}

export default Context;



// WEBPACK FOOTER //
// ./src/context/context.js